import { useState } from 'react';
import { Collapse } from 'reactstrap';
import Icon from '../../assets/icons/Icon';
import { useDict } from '../../contexts/LanguageContext';
import { useStatementDispatch } from '../../contexts/StatementContext';
import ROUTE_NAME from '../../routes/RouteName';
import TopbarMenuLink from './TopbarMenuLink';

const TopbarMore = () => {
    const dict = useDict();

    const statementDispatch = useStatementDispatch();

    const [collapse, setCollapse] = useState(false);

    const toggle = () => {
        setCollapse(!collapse);
    };

    return (
        <div className="topbar__profile" data-tut="do_more">
            <button
                className="topbar__avatar"
                type="button"
                onClick={toggle}
                data-cy="topbar__moreBtn"
            >
                {dict.more}
                <Icon icon="ChevronDown" className="topbar__icon" />
            </button>
            {collapse && (
                <button
                    className="topbar__back"
                    type="button"
                    onClick={toggle}
                />
            )}
            <Collapse isOpen={collapse} className="topbar__menu-wrap">
                <div className="topbar__menu" data-cy="topbar__menu">
                    <span>
                        <TopbarMenuLink
                            title={dict.transaction}
                            icon="ExchangeAlt"
                            path={ROUTE_NAME.TRANSACTION}
                            onClick={toggle}
                            data-cy="topbar__navLink--transaction"
                        />
                        <TopbarMenuLink
                            title={
                                <>
                                    {dict.myStatements} {' '}
                                    <span className="invest-now-badge font-size-8">{dict.comingSoon}</span>
                                </>
                            }
                            icon="List"
                            path="#"
                            onClick={toggle}
                            // onClick={() => statementDispatch({ type: 'openStatementOptionModal' })} // disabled for now
                            data-cy="topbar__navLink--myStatement"
                        >
                        </TopbarMenuLink>
                        <TopbarMenuLink
                            title={dict.myProfile}
                            icon="User"
                            path={ROUTE_NAME.PROFILE}
                            onClick={toggle}
                            data-cy="topbar__navLink--myProfile"
                        />
                        <TopbarMenuLink
                            title={dict.faqUserGuide}
                            icon="QuestionCircle"
                            path={ROUTE_NAME.FAQ_GENERAL_ENQUIRIES}
                            onClick={toggle}
                            data-cy="topbar__navLink--faq"
                        />
                    </span>
                </div>
            </Collapse>
        </div>
    );
};

export default TopbarMore;
